<template>
  <div
    class="anz-post-tooltip anz-post-tooltip--close-absolute anz-position-relative anz-bg-orange-light anz-py-l anz-b-rounded anz-flex anz-align-items-start"
    v-if="calledReportAction"
  >
    <div class="anz-flex anz-align-items-start anz-flex-fill">
      <h6
        class="anz-fs-xs anz-flex anz-align-items-center anz-flex-wrap anz-flex-fill anz-justify-content-center"
      >
        <template v-if="alreadyPerformed">
          {{ $translate('post.actionResults.alreadyReported') }}
        </template>
        <template v-else>
          {{ $translate('post.actionResults.reported') }}
        </template>
      </h6>
      <a-button
        class-name="anz-post-tooltip__closer anz-link anz-color-beige anz-ml-m anz-mtn-xs anz-block"
        @click="$emit('tooltip-close')"
        show-icon
        icon-width="0.7142em"
        icon-height="0.7142em"
        icon-name="cross-solid"
        icon-class="anz-block anz-mtn-xxs"
      />
    </div>
  </div>
  <div
    class="anz-post-tooltip anz-post-tooltip--close-absolute anz-position-relative anz-bg-orange-light anz-py-l anz-b-rounded anz-flex anz-align-items-start"
    v-else
  >
    <div
      class="anz-flex-sm anz-align-items-center anz-flex-fill anz-align-center anz-align-left-sm"
    >
      <div>
        <h6 class="anz-fs-xs anz-mb-xs">
          {{ $translate('post.actionResults.reportedConfirmation') }}
        </h6>
        <a-checkbox
          class="anz-mr-auto anz-pr-s anz-justify-content-center anz-justify-content-start-sm"
          v-model="checked"
        >
          <template #title>
            {{ $translate('post.actionResults.reportedConfirmationText') }}
            <a-button
              :title="
                $translate('post.actionResults.reportedConfirmationCodex')
              "
              class-name="anz-link anz-color-primary anz-link-underline anz-strong"
              :href="generateCodexRoute()"
              add-href
              :target-blank="true"
            />
          </template>
        </a-checkbox>
      </div>
      <a-button
        className="anz-btn anz-btn-primary anz-btn-s anz-fc-icon anz-mt-s anz-mt-0-sm anz-wf-mo anz-ml-auto anz-mr-auto"
        :title="$translate('post.actionResults.reportedConfirmationAction')"
        :loading="isReporting"
        :disabled="isReporting || !checked"
        @click="reportPost"
        icon-width="0.7142em"
        icon-height="0.7142em"
        icon-class="anz-mr-xs"
        loader-class="anz-spinner-xxs"
      ></a-button>
    </div>
    <a-button
      class-name="anz-post-tooltip__closer anz-link anz-color-beige anz-ml-m anz-block"
      :style="{ marginTop: '-4px' }"
      @click="$emit('tooltip-close')"
      show-icon
      icon-width="0.7142em"
      icon-height="0.7142em"
      icon-name="cross-solid"
      icon-class="anz-block anz-mtn-xxs"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { TOOLTIP_COMPONENTS } from '@/composables/post/postTooltip'
import AButton from '@/components/Forms/AButton.vue'
import ACheckbox from '@/components/Forms/ACheckbox.vue'
import { Post } from '@/model/data-object/Post'
import usePostReport from '@/composables/postReport/postReport'
import { useRouter } from '@/routing/router'

export default defineComponent({
  name: TOOLTIP_COMPONENTS.POST_REPORT_CONFIRMATION,
  emits: ['tooltip-close'],
  components: { AButton, ACheckbox },
  props: {
    alreadyPerformed: {
      type: Boolean,
      default: false,
    },
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      checked: false,
    }
  },
  setup(props) {
    return {
      ...usePostReport(props.post as Post),
      ...useRouter(),
    }
  },
})
</script>
